import {TechnicalIndicatorsService} from "./service/TechnicalIndicatorsService";
import {TechnicalIndicatorsStore} from "./store/TechnicalIndicatorsStore";

const ModuleName = "tfApp.technical-indicators";

export default angular.module(ModuleName, [])
                      .service(TechnicalIndicatorsService.id, TechnicalIndicatorsService)
                      .service(TechnicalIndicatorsStore.id, TechnicalIndicatorsStore)
                      .name;
